var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
var cls = classNames('page-featured-posts');
export var SliceInlineBannerDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    height: 100%;\n    line-height: 1.0em;\n    box-sizing: border-box;\n    align-items: center;\n    display: flex;\n    max-width: 500px;\n    font-weight: 400;\n    font-size: ", "em;\n  "], ["\n    color: ", ";\n    font-family: ", ";\n    height: 100%;\n    line-height: 1.0em;\n    box-sizing: border-box;\n    align-items: center;\n    display: flex;\n    max-width: 500px;\n    font-weight: 400;\n    font-size: ", "em;\n  "])), theme.COLOR('light'), theme.FONT('serif'), 36 / 15),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 50 / 16),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 64 / 17)
}); // -------- Components -------->

var My = {
  Container: styled.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SliceInlineBanner = function SliceInlineBanner(props) {
  var _a, _b;

  var className = props.className,
      entity = props.entity;
  var text = entity.title || ((_a = entity.intro) === null || _a === void 0 ? void 0 : _a.text) || ((_b = entity.content) === null || _b === void 0 ? void 0 : _b.text);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, text);
};
SliceInlineBanner.defaultProps = SliceInlineBannerDefaultProps;
SliceInlineBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;